import React from "react"

import { useTranslation } from "react-i18next"

import { StatusCounts } from "services/bonus/type"

interface Props {
  statusCounts: StatusCounts
  totalPlayerBonuses: number
}

const STATUS_COLOR_MAP: Record<string, string> = {
  SUBSCRIBED: "bg-gray-500",
  ACTIVE: "bg-blue-500",
  COMPLETED: "bg-emerald-500",
  EXPIRED: "bg-orange-500",
  CANCELLED: "bg-rose-500"
}

export const StatusBreakdownCard = ({ statusCounts, totalPlayerBonuses }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const total = totalPlayerBonuses || 1

  return (
    <div className="rounded-3xl border p-6 shadow-[0px_1px_12px_0px_rgba(0,0,0,0.04)] border-[rgba(0,0,0,0.05)] bg-white backdrop-blur-[9px] dark:border-[rgba(255,255,255,0.1)] dark:bg-[rgba(255,255,255,0.04)] dark:backdrop-blur-md dark:shadow-none">
      <h4 className="font-semibold mb-4 text-[rgba(6,7,21,1)] dark:text-white">{t("bonus2.analytics.statusBreakdown")}</h4>
      <div className="space-y-3">
        {Object.entries(statusCounts).map(([status, count]) => {
          const percentage = (count / total) * 100
          return (
            <div key={status}>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-600 dark:text-gray-300">{status}</span>
                <span className="font-semibold text-[rgba(6,7,21,1)] dark:text-white">
                  {count} ({percentage.toFixed(1)}%)
                </span>
              </div>
              <div className="rounded-full h-2 bg-gray-200 dark:bg-gray-700">
                <div className={`${STATUS_COLOR_MAP[status] || "bg-gray-500"} h-2 rounded-full`} style={{ width: `${percentage}%` }} />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
